const apiFunction = (input, url, method) => {
  const { token, ...body } = input;

  return {
    url: url,
    method: method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: { ...body },
  };
};

const isDev = process.env.NODE_ENV === "development";

const URL = {
  url1: process.env.REACT_APP_API_URL || "http://localhost:5001/",
  url: isDev
    ? process.env.REACT_APP_API_URL || "http://localhost:5001/"
    : "",
};

export { apiFunction, URL };
